import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getProfilePackages } from 'modules/settings/api';

export const useQueryProfilePackages = () => {
  // Fetching profile packages
  const {
    error: errPackages,
    data: dataPackages,
    isLoading: isLoadingPackages,
  } = useQuery(QUERY_KEYS.SETTINGS_PROFILE_PACKAGES, getProfilePackages);

  return {
    isLoadingPackages,
    errPackages,
    packages: dataPackages?.data,
  };
};
